import { requestHandler } from 'lib/api';

export const getAllSGRWarrantyRequests = async (
  dispatch: any,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessSGRWarrantyRequests = async (
  dispatch: any,
  businessIdentifier: string,
  query: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest/${businessIdentifier}?${query}`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSGRWarrantyRequestMissingApprovals = async (
  dispatch: any,
  warrantyRequestId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/missing-approvals`,
    dispatch,
  });
  if (response) return response.data;
};

export const getSGRWarrantyRequestFile = async (
  dispatch: any,
  warrantyRequestId: number,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/file`,
    dispatch,
    responseType: 'text',
  });
  if (response) return response.data;
};

export const getPublicSGRWarrantyRequestFile = async (
  dispatch: any,
  secretId: string,
  warrantyRequestId: number,
  clientIdentifier: string,
  principalIdentifier: string,
  warrantyType: string,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `public/express/${secretId}/sgrWarrantyRequestFile/${warrantyRequestId}/${clientIdentifier}/${principalIdentifier}/${warrantyType}`,
    dispatch,
    responseType: 'text',
  });
  if (response) return response.data;
};

export const createSGRWarrantyRequest = async (dispatch: any, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/sgrWarrantyRequest`,
    dispatch,
    data,
  });

  if (response) return response.data;
};

export const createSGRWarrantyRequestPruffConnect = async (
  dispatch: any,
  secretId: string,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/express/${secretId}/sgrWarrantyRequest`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const updateSGRWarrantyRequest = async (
  dispatch: any,
  warrantyRequestId: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}`,
    dispatch,
    data,
  });

  if (response) return response.data;
};

export const updateSGRWarrantyRequestComitee = async (
  dispatch: any,
  warrantyRequestId: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/comitee`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const approveSGRWarrantyRequest = async (
  dispatch: any,
  warrantyRequestId: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/approve`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const rejectSGRWarrantyRequest = async (
  dispatch: any,
  warrantyRequestId: number,
  data: any,
) => {
  const response = await requestHandler({
    method: 'put',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/reject`,
    dispatch,
    data,
  });
  if (response) return response.data;
};

export const deleteSGRWarrantyRequest = async (
  dispatch: any,
  warrantyRequestId: number,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}`,
    dispatch,
  });

  if (response) return response.data;
};

export const deleteSGRWarrantyRequestApproval = async (
  dispatch: any,
  warrantyRequestId: number,
  approvalId: number,
) => {
  const response = await requestHandler({
    method: 'delete',
    url: `internal/sgrWarrantyRequest/${warrantyRequestId}/approval/${approvalId}`,
    dispatch,
  });
  if (response) return response.data;
};
